import React from 'react';
import { Search } from 'lucide-react';

const BAR_STYLE = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.75rem',
  alignItems: 'center',
  margin: '0 0 1rem',
  padding: '0.75rem',
  background: 'rgba(255, 215, 0, 0.04)',
  border: '1px solid rgba(255, 215, 0, 0.18)',
  borderRadius: '10px',
};

const INPUT_STYLE = {
  width: '100%',
  padding: '0.5rem 0.5rem 0.5rem 2rem',
  borderRadius: '8px',
  border: '1px solid rgba(255,215,0,0.3)',
  background: '#0a0a0a',
  color: '#fff',
  fontSize: '0.95rem',
};

const SELECT_STYLE = {
  padding: '0.5rem 0.75rem',
  borderRadius: '8px',
  border: '1px solid rgba(255,215,0,0.3)',
  background: '#0a0a0a',
  color: '#fff',
  fontSize: '0.9rem',
};

const ContactsSearchBar = ({
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  filteredCount,
  totalCount,
}) => (
  <div className="admin-search-bar" style={BAR_STYLE}>
    <div style={{ position: 'relative', flex: '1 1 280px', minWidth: '220px' }}>
      <Search size={16} style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#FFD700' }} />
      <input
        type="search"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search name, email, phone, subject, or message…"
        data-testid="contacts-search-input"
        style={INPUT_STYLE}
      />
    </div>
    <select
      value={statusFilter}
      onChange={(e) => setStatusFilter(e.target.value)}
      data-testid="contacts-status-filter"
      style={SELECT_STYLE}
    >
      <option value="all">All Statuses</option>
      <option value="unread">Unread</option>
      <option value="read">Read</option>
    </select>
    <span style={{ color: '#FFD700', fontSize: '0.85rem', fontWeight: 600 }} data-testid="contacts-filtered-count">
      {filteredCount} of {totalCount}
    </span>
  </div>
);

export default ContactsSearchBar;
